// src/utils/Scrolls.js

/**
 * Smoothly scroll page to the top.
 * Used by components/_ui/ScrollUp/ScrollUp.js
 */
export const handleScrollToTop = (behavior = "smooth") => {
  try {
    window.scrollTo({ top: 0, left: 0, behavior });
  } catch {
    // older browsers
    window.scrollTo(0, 0);
  }
};

/**
 * Attach scroll listener that toggles compact header state.
 * Adds .is-scrolled to .menu-bar and syncs .component/.ribbon tall/short.
 * Returns a cleanup function.
 */
export const attachHeaderScroll = () => {
  const header = document.querySelector(".menu-bar");
  if (!header) return () => {};

  const comp = header.querySelector(".component");
  const ribbon = header.querySelector(".ribbon");

  const onScroll = () => {
    const y = window.scrollY || window.pageYOffset;
    const scrolled = y > 40;

    header.classList.toggle("is-scrolled", scrolled);

    // keep legacy classes in sync (if styles rely on them)
    if (comp) {
      comp.classList.toggle("tall", !scrolled);
      comp.classList.toggle("short", scrolled);
    }
    if (ribbon) {
      ribbon.classList.toggle("tall", !scrolled);
      ribbon.classList.toggle("short", scrolled);
    }
  };

  onScroll(); // initialize
  window.addEventListener("scroll", onScroll, { passive: true });

  return () => window.removeEventListener("scroll", onScroll);
};
